import { useQuery } from '@tanstack/react-query';
import { api } from 'src/constants/apiRoutes';
import { queryKeys } from 'src/constants/querykeys';
import { IPostBody } from 'src/types/PostBody';
import { IReceipt } from 'src/types/Receipt';
import axiosInstance from 'src/utils/axios';

export interface ReceiptListResponse {
  items: IReceipt[];
  totalRecords: number;
}

async function fetchReceiptList(
  companyId: string,
  postBody: IPostBody
): Promise<ReceiptListResponse> {
  const response = await axiosInstance.post<ReceiptListResponse>(
    api.filterReceipts(companyId),
    postBody
  );
  return response.data;
}

export interface UseReceiptListQueryOptions {
  companyId: string;
  postBody: IPostBody;
}

export function useReceiptListQuery({ companyId, postBody }: UseReceiptListQueryOptions) {
  return useQuery<ReceiptListResponse>({
    queryKey: queryKeys.receipt.receiptList(companyId, postBody),
    queryFn: () => fetchReceiptList(companyId, postBody),
    enabled: Boolean(companyId),
  });
}
